import React from 'react'

export const changepassword = () => {
  return (
    <div>changepassword</div>
  )
}
